<template>
    <div class="edit">
        <p-header title="編輯任務" :leftIcon="require('@/assets/img/chat.svg')" @onLeftBtn="goToChat"/>
        <div class="body">
            <div class="title">請選擇取消任務的原因（可複選）</div>
            <div class="description">
                取消任務會酌收部分費用，依結算時間為準<br>
                <span>另系統會自動退還您的預刷款項。</span>
            </div>
            <div class="options">
                <div class="option" :class="{selected: isSelected('slow')}" @click="select('slow')">騎士超過30分鐘還沒抵達</div>
                <div class="option" :class="{selected: isSelected('shop')}" @click="select('shop')">店家沒開、東西賣完要取消</div>
                <div class="option" :class="{selected: isSelected('knight')}" @click="select('knight')">騎士叫我取消任務</div>
                <div class="option" :class="{selected: isSelected('other')}" @click="select('other')">
                    其它：
                    <div class="other" v-show="isSelected('other')" @click.stop>
                        <a-textarea v-model="other" placeholder="請填寫其他的原因"></a-textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="button" @click="cancel">
                取消任務
            </div>
        </div>
        <loading loader="spinner"
                 :active="isLoading"
                 :width="25"
                 :height="25"/>
        <cancel-modal ref="cancelModal" @onConfirm="onConfirm"/>
        <revoke-order ref="revokeOrder" @onConfirm="revoke"/>
    </div>
</template>

<script>
    import header from "./components/Header";
    import {cancelTrial} from "../apis";
    import { mapActions, mapGetters } from 'vuex';
    import Swal from "sweetalert2";
    import CancelModal from "./components/modal/CancelOrderModal";
    import ATextare from "./components/AutoHeighTextarea";
    import Loading from "vue-loading-overlay";
    import RevokeOrder from "./components/modal/RevokeOrderModal";

    export default {
        name: "OrderEdit",
        components: {
            'p-header': header,
            'cancel-modal': CancelModal,
            'revoke-order': RevokeOrder,
            'a-textarea': ATextare,
            'loading': Loading,
        },
        data() {
            return {
                orderId: 0,
                isLoading: false,
                selected: [],
                other: '',
                cancelPrice: 0,
            }
        },
        computed: {
            order() {
                return this.orderById(this.orderId) || {
                    prices: {
                        behalf: 0,
                        base: 0,
                        distance: 0,
                        multiple: 0,
                        wait: 0,
                        tip: 0,
                        discount: 0,
                        prepaid: 0,
                    }
                };
            },
            ...mapGetters(['orderById'])
        },
        methods: {
            cancel() {
                this.cancelPrice = 0;
                if (this.order.status !== 'processing') {
                    return this.$refs.revokeOrder.show()
                }

                this.isLoading = true;
                cancelTrial(this.orderId).then(res => {
                    let payload = {
                        data: {
                            types: this.selected,
                            other: this.other,
                        }
                    }
                    this.cancelPrice = res.data.price;
                    this.$refs.cancelModal.show(res.data.price, this.orderId, payload);
                    this.isLoading = false;
                }).catch(err => {
                    this.isLoading = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            },
            revoke() {
                this.isLoading = true;
                let payload = {
                    id: this.orderId,
                    data: {
                        types: this.selected,
                        other: this.other,
                    }
                }
                this.revokeOrder(payload).then(() => {
                    this.isLoading = false;
                    this.onConfirm();
                }).catch(err => {
                    this.isLoading = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            },
            goToChat() {
                window.open('https://line.me/R/ti/p/%40hjc7084c');
            },
            select(type) {
                let index = this.selected.findIndex(item => item === type);
                if (index >= 0) {
                    this.selected.splice(index, 1);
                } else {
                    this.selected.push(type);
                }
            },
            isSelected(type) {
                return this.selected.findIndex(item => item === type) >= 0;
            },
            onConfirm() {
                this.$router.replace({
                    name: 'orderCancel',
                    params: {
                        price: this.cancelPrice,
                        prepaid: this.order.prices.prepaid,
                    }
                })
            },
            ...mapActions(['getOrder', 'revokeOrder'])
        },
        created() {
            this.orderId = this.$route.params.id;
            this.getOrder(this.orderId).then(res => {
                if (res.data.status !== 'processing' && res.data.status !== 'dispatching' && res.data.status !== 'missing' && res.data.status !== 'sending' && res.data.status !== 'appointing') {
                    this.$router.replace({
                        name: 'order',
                        params: {
                            id: this.orderId,
                        }
                    })
                }
            }).catch(err => {
                if (err.response.status === 403 || err.response.status === 404) {
                    this.$router.replace({
                        name: 'home'
                    })
                }
            });
        }
    }
</script>

<style lang="scss" scoped>
    .edit {
        text-align: left;
        position: relative;
        flex: 1;

        .body {
            padding: 15px 25px;
            margin-bottom: 66px;

            .title {
                font-size: 18px;
                font-weight: 500;
            }

            .description {
                font-size: 14px;
                margin-top: 10px;
                span {
                    color: #F44336;
                }
            }

            .options {
                padding: 15px 0;
                cursor: pointer;

                .option {
                    user-select: none;
                    color: #4A4A4A;
                    font-size: 14px;
                    margin-top: 10px;
                    padding: 5px 10px;
                    border-radius: 5px;
                    box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);

                    &.selected {
                        color: #339933;
                        border: 1px solid #339933;
                    }
                }
            }

            .other {
                margin-top: 10px;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
                border-radius: 5px;
                padding: 5px;

                textarea {
                    min-height: 100px !important;
                }
            }
        }

        .footer {
            position: absolute;
            bottom: 0;
            padding: 10px 15px;
            width: calc(100% - 30px);

            .button {
                border-radius: 35px;
                background-color: #339933;
                font-size: 14px;
                text-align: center;
                padding: 13px;
                color: #FFFFFF;
                cursor: pointer;
                user-select: none;

            }
        }
    }
</style>